
import React, {/*useState, useEffect*/} from 'react';
//import { Link, useHistory } from 'react-router-dom';
//import axios from "axios";
//import api from '../../services/api';
import { GrFacebook, GrInstagram/*, GrMail*/ } from 'react-icons/gr';
import { FaStoreAlt/*, FaUser, FaKey, FaBuilding*/ } from 'react-icons/fa';
// import { AiFillCloseCircle, AiFillEyeInvisible, AiFillEye, AiFillCalendar/*, AiFillStar*/ } from 'react-icons/ai';
// import { IoFingerPrintSharp} from 'react-icons/io5';
// import { FiArrowLeft } from 'react-icons/fi';
// import { MdSmartphone } from 'react-icons/md';
// import { GoTriangleDown } from 'react-icons/go';
// import { ImExit } from 'react-icons/im';


//import ReCAPTCHA from "react-google-recaptcha";


import './Topbar.css';

//const token = localStorage.getItem('token');

function Topbar() {

  // const [open, setOpen ]  = useState(false);
  // const [type, setType] = useState('password');
  // const [modal, setModal] = useState(false);
  // const [icon, setIcon] = useState(false);
  // const [modalContentLogin, setModalContentLogin] = useState(true);
  // const [modalContentForgotPassword, setModalContentForgotPassword] = useState(false);
  // const [modalContentCadastro, setModalContentCadastro] = useState(false);
  // const [login, setLogin] = useState('');
  // const [senha, setSenha] = useState('');
  // const [username, setUserName ] = useState(null);
  // const [fail, setFail] = useState(false);
  // const history = useHistory();

  // const handleLogin = () => {
  //   setModal(true);
  //   setModalContentLogin(true);
  //   setModalContentCadastro(false);
  //   setModalContentForgotPassword(false);
  // }

  // const handleCadastro = () => {
  //   setModalContentCadastro(true);
  //   setModalContentLogin(false);
  //   setModalContentForgotPassword(false);
  // }

  // const handlePassword = () => {
  //   setType(type === 'text' ? 'password' : 'text');
  //   setIcon(icon === true ? false : true);
  // }

  // const handleForgotPassword = () => {
  //   setModal(true);
  //   setModalContentForgotPassword(true);
  //   setModalContentLogin(false);
  //   setModalContentCadastro(false);
  // }

  // const handleBack = () => {
  //   setModalContentLogin(true);
  //   setModalContentForgotPassword(false);
  //   setModalContentCadastro(false);
  // }

  // const reCaptcha = (value) => {
  //   console.log("Captcha value:", value);
  // }
  
  // async function handleFormLogin(e){
  //   setFail(false);

  //   e.preventDefault();
  //   const username = login;
  //   const password = senha;
    
  //   try {

  //     const response = await api.post('/login', {login: username, senha: password });
  //     const data = await response.data.message;
  //     const token = await response.data.token;
    
  //     if(!data){
  //       localStorage.setItem('token', token);
  //       api.defaults.headers.Authorization = `Bearer ${token}`;
  //       window.location.reload();
  //     }else{  
  //       setFail(data);
  //       history.push('/');
  //     }

  //   } catch (error) {
  //     console.error(error) 
  //   }
  // }

  // useEffect(() => {
  //   axios.get('https://api-sdc.herokuapp.com/user', { 
  //     headers: {
  //       Accept: 'application/json',
  //       'Content-Type': 'application/json', 
  //       'Authorization': `Bearer ${token }`
  //     } 
  //   }).then(response => {
  //     setUserName(response.data);
  //   }).catch(error => {
  //     console.log('Erro', error);
  //   });
  // }, []);

  // async function handleLogout() {

  //   localStorage.removeItem('token');
  //   window.location.reload();
  // }

  return (
    <>
      {/* {modalContentLogin && (
        <>
          <div className={modal ? "modal-bg show-modal" : "modal-bg"}>
            <div className={fail ? "fail fail-show" : "fail"}>{fail}</div>
            <div className="modal-contato modal-top-bar">
              <div className="identificação">
                <h2>Identificação</h2>
              </div>
              <AiFillCloseCircle size={30} color="#485860" className="modal-icon" onClick={() => setModal(false)} />
              <div className="modal-content-contato modal-top-bar-content">
                <form onSubmit={handleFormLogin} method="POST">              
                  <div className="mb-input">
                    <input type="text" name="login" id="login" placeholder="e-mail ou cpf" value={login} onChange={e => setLogin(e.target.value)} />
                    <label><FaUser color="#dbdbdb" size={18} /></label>
                  </div>
                  <div className="last-input">
                    <input type={type} name="senha" id="senha" placeholder="senha" value={senha} onChange={e=> setSenha(e.target.value)}  />
                    <label><FaKey color="#dbdbdb" size={18} /></label>
                    <label className="view">
                      {
                        icon ? <AiFillEye color="#dbdbdb" size={25} onClick={handlePassword} /> : <AiFillEyeInvisible color="#dbdbdb" size={25} onClick={handlePassword} />
                      }
                    </label>
                  </div>
                  <span onClick={handleForgotPassword}>Esqueci a minha senha</span>
                  <button className="form-button-identifica" type="submit">Entrar</button>
                </form>
               
              </div>
              <button className="cadastrar" onClick={handleCadastro}>Quero me cadastrar</button>
            </div>
          </div>
        </>
      )}
      {
        modalContentCadastro && (
          <>
            <div className={modal ? "modal-bg show-modal" : "modal-bg"}>
              <div className="modal-contato modal-top-bar">
                <div className="identificação">
                  <h2>Identificação</h2>
                </div>
                <div className="voltar" onClick={handleBack}>
                  <h3>Voltar</h3>
                  <FiArrowLeft size={30} color="#ffffff" />
                </div>
                <AiFillCloseCircle size={30} color="#485860" className="modal-icon" onClick={() => setModal(false)} />
                <div className="header-form">
                  <h2>Cadastro</h2>
                  <span><i>*preenchimento obrigatórios</i></span>
                </div>
                <div className="modal-content-contato modal-top-bar-content">
                  <form>              
                    <div className="mb-input">
                      <input type="email" name="email" placeholder="*e-mail" />
                      <label><GrMail color="#dbdbdb" size={18} /></label>
                    </div>
                    <div className="mb-input">
                      <input type="tel" name="cpf" placeholder="*CPF" />
                      <label><IoFingerPrintSharp color="#dbdbdb" size={18} /></label>
                    </div>
                    <div className="mb-input">
                      <input type="text" name="nome" placeholder="*nome" />
                      <label><FaUser color="#dbdbdb" size={18} /></label>
                    </div>
                    <div className="mb-input">
                      <input type="text" name="sobrenome" placeholder="*sobrenome" />
                      <label><FaUser color="#dbdbdb" size={18} /></label>
                    </div>
                    <div className="mb-input">
                      <input type="text" name="data_nasc" className="date" placeholder="*data de nascimento" />
                      <label><AiFillCalendar color="#dbdbdb" size={18} /></label>
                    </div>
                    <div className="mb-input input-radios">
                      <div><h3>Gênero</h3></div><br />
                      <div><input type="radio" name="genero" id="feminino" value="feminino"/> Feminino</div>
                      <div><input type="radio" name="genero" id="masculino" value="masculino"/> Masculino</div>
                      <div><input type="radio" name="genero" id="nao_informar" value="nao_informar"/> Prefiro não informar</div>
                    </div>
                    <div className="mb-input">
                        <input type={type} name="senha" placeholder="senha"  />
                        <label><FaKey color="#dbdbdb" size={18} /></label>
                        <label className="view">
                          {
                            icon ? <AiFillEye color="#dbdbdb" size={25} onClick={handlePassword} /> : <AiFillEyeInvisible color="#dbdbdb" size={25} onClick={handlePassword} />
                          }
                        </label>
                        <div className="infos-input"><p>(Mínimo de 6 caracteres)</p></div>
                    </div>
                    <div className="mb-input">
                        <input type="tel" name="telefone" placeholder="*telefone" />
                        <label><MdSmartphone color="#dbdbdb" size={18} /></label>
                        <div className="infos-input"><p>(DDD + número)</p></div>
                    </div>
                    <div className="mb-input input-checkbox">
                      <div><input type="checkbox" name="info_mail" /> <p>Quero receber promoções e novidades por email</p></div><br />
                      <div><input type="checkbox" name="sms"/> <p>Quero receber informações do meu pedido por SMS</p></div><br />
                      <div><input type="checkbox" name="whatsapp"/> <p>Quero receber notificações pelo Whatsapp</p></div><br />
                      <div><input type="checkbox" name="aceito"/> <p>Li e aceito a Política de Privacidade e Proteção de Dados e os Termos de Uso.</p></div>
                    </div>
                    <div className="mb-input">
                      <div id="g-recaptcha">
                        
                        <ReCAPTCHA sitekey="6LevRB4aAAAAAHWXOsz_zG5cQ5NlLZygq47lfCIP" onChange={reCaptcha} size="normal" />
                      </div>
                    </div>
                  </form>
                  <button className="form-button-identifica">Cadastrar</button>
                </div>
              </div>
            </div>
          </>
        )
      }
      {
        modalContentForgotPassword && (
          <>
            <div className={modal ? "modal-bg show-modal" : "modal-bg"}>
              <div className="modal-contato modal-top-bar">
                <div className="identificação">
                  <h2>Esqueci minha senha</h2>
                </div>
                <AiFillCloseCircle size={30} color="#485860" className="modal-icon" onClick={() => setModal(false)} />
                <div className="modal-content-contato modal-top-bar-content">
                  <form>              
                    <div className="mb-input">
                      <input type="text" name="cpf" placeholder="digite seu cpf" />
                      <label><IoFingerPrintSharp color="#dbdbdb" size={22} /></label>
                    </div>
                    <p>As informações para redefinição de senha serão enviadas para o e-mail cadastrado.</p>
                    <br /><br />
                  </form>
                  <button className="form-button-identifica">Recuperar minha senha</button>
                </div>
              </div>
            </div>
          </>
        )
      } */}
      <div className="top-bar">
        <div className="container">
          <div>
            <ul>
            <li>
              <a href="https://www.instagram.com/_shoppingparquedacidade/" target="_blank" rel="noreferrer" title="Instagra,">
                <GrInstagram color="#fff" size={16} />
              </a>
            </li>
            <li>
              <a href="https://www.facebook.com/shoppingparquedacidade" target="_blank" rel="noreferrer" title="Facebook">
                <GrFacebook color="#fff" size={16} />
              </a>
            </li>
            </ul>
          </div>
          <div>
            <ul>
              {/* <li className="cadastrese" onMouseEnter={() => setOpen(true)}>
                {token ? 
                  <>
                    <span> Olá, <strong>{username}</strong> <GoTriangleDown size={16} /></span> 
                    {open && (
                      <ul className="logado" onMouseLeave={() => setOpen(false)}>
                        <li><FaUser color="#485860" size={16} className="icone" /> <Link to="/painel">Meu cadastro</Link></li>
                        <li><FaBuilding color="#485860" size={16} className="icone" /> <Link to="/endereco">Meus endereços</Link></li>
                        <li><FaKey color="#485860" size={16} className="icone" /> <Link to="/alterarsenha">Alterar senha</Link></li>
                        <li><ImExit color="#485860" size={16} className="icone" /> <Link to="/" onClick={handleLogout}>Sair</Link></li>
                      </ul>
                    )}
                  </> : 
                  <>
                    <FaUser color="#fff" size={16} className="icone" /><Link to="#" onClick={handleLogin}> Entre ou cadastre-se</Link>
                  </>
                } 
              </li> */}
              <li><FaStoreAlt color="#fff" size={16} className="icone" /> <a href="https://www.intranetmall.com/shoppingparquedacidade/">Área do lojista</a></li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default Topbar;




